import {FC} from "react";
import {Trans, useTranslation} from "react-i18next";
import {Card, CardContent, CardHeader} from "@interstate/components/Card";
import "./SummaryCard.scss";

export interface SummaryCardProps {
  baseLabelKey: string;
  qualifier: string;
  count: number;
}

export const SummaryCard: FC<SummaryCardProps> = ({
  baseLabelKey,
  qualifier,
  count
}) => {
  const {t} = useTranslation();
  return (
    <Card
      id={`create-organization-${qualifier}-summary-card`}
      data-testid={`create-organization-${qualifier}-summary-card`}
      className={`create-organization-summary-card create-organization-${qualifier}-summary-card`}
      header={<CardHeader title={t(`${baseLabelKey}.${qualifier}.title`)} />}
      content={
        <CardContent>
          <Trans
            i18nKey={`${baseLabelKey}.${qualifier}.content`}
            values={{count}}
            components={{bold: <strong className={"summary-card-count"} />}}
          />
        </CardContent>
      }
    />
  );
};
